import * as application from './application';
import * as channels from './channels';
import * as customer from './customer';
import * as transaction from './transaction';
export {
  application,
  channels,
  customer,
  transaction,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/index.ts